// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__DydJp","imageUploader":"EGiftCard_imageUploader__1TooK"};